import { RouteRecordRaw } from 'vue-router'

export const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		redirect: '/platba',
		component: () => import('@/plugins/app/layout/payment/payment.layout.vue'),
		children: [
			{
				path: '/platba/:orderVariableSymbol/:paymentRequestId',
				name: 'Platba',
				component: () => import('@/plugins/app@payment/payment/payment.vue')
			}
		]
	}
]
